module.exports = __webpack_public_path__ + "img/2010_disrespectoids_slide6.b900478a.jpg";